import { CpfCnsModel } from 'components/model-CpfCns'
import { createValidator, ErrorObject } from 'util/validation'
import {
  hasSameCpfCns,
  MSG_PROFISSIONAL_DEVE_SER_DIFERENTE_CIDADAO_PART,
} from 'view/atividade-coletiva/saude/utils-atividadeColetivaSaude'

import { LotacaoEditableTableModel } from './LotacaoEditableTable'

export const lotacaoEditableTableValidator = (
  allItems: LotacaoEditableTableModel[],
  cpfCnsCidadaosParticipantes: CpfCnsModel[]
) =>
  createValidator<LotacaoEditableTableModel>(
    {},
    (model: LotacaoEditableTableModel, errors: ErrorObject<LotacaoEditableTableModel>) => {
      if (!model?.lotacao) return errors

      const profissional = model.lotacao.profissional

      if (allItems.some((item) => item.lotacao.profissional.id === profissional.id)) {
        errors.lotacao = 'Profissional já adicionado'
      } else if (cpfCnsCidadaosParticipantes?.some((cidadao) => hasSameCpfCns(cidadao, profissional))) {
        errors.lotacao = MSG_PROFISSIONAL_DEVE_SER_DIFERENTE_CIDADAO_PART
      }

      return errors
    }
  )
